module.exports = __webpack_public_path__ + "715cd5c1e827ed89b8cd2af8e4157276.pdf";